import basicSettingApi from '@/api/basicSetting/basicSettingApi'

export default {
	name: 'data-usage-remind',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {};
	},
	computed: {

	},
	watch: {},
	created() {},
	mounted() {
        this.init();
    },
	updated() {},
	beforeDestroy() {},
	methods: {
        async init(){
            await basicSettingApi.permissionValidation();
        }
    },
};



// WEBPACK FOOTER //
// ./src/components/basicSetting/staticView/dataUsageRemind.js